import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Slack = {
    vv1: {
        postMessage: { method: HttpMethod.POST, path: 'v1/slack/post-message' },
        postStructuredMessage: { method: HttpMethod.POST, path: 'v1/slack/post-structured-message' },
        sendFEMessage: { method: HttpMethod.POST, path: 'v1/slack/send-fe-message' },
        postFiles: { method: HttpMethod.POST, path: 'v1/slack/post-files' },
    }
};
//# sourceMappingURL=apis.js.map